module.exports = __webpack_public_path__ + "static/media/low_battery.e847f658.svg";